import { Layer } from '@carto/kepler.gl/layers'

import { MapType } from 'features/maps/types'
import { BuilderDataset, KeplerTable, MapDatasetEnriched, Widget, WidgetStateType } from '../types'
import { RangeWidget, WidgetType } from 'features/builder'

export function canUseGlobal(source: MapDatasetEnriched) {
  return canUseModelAPI(source)
}

export function isGlobalModeForced(source: MapDatasetEnriched | KeplerTable | undefined, sourceHasAnyLayer: boolean) {
  return Boolean(!source?.metadata?.tilejson || !sourceHasAnyLayer)
}

export function canUseModelAPI(source: { type: MapType }) {
  const { type } = source
  return type !== MapType.tileset && type !== MapType.raster
}

export function findFirstRangeWidgetFromDataSourceWithCustomMinMaxAndColumn(
  widgets: Widget[],
  dataSourceId: string,
  column?: string
) {
  const firstRangeWidgetFromDataSource = widgets
    .filter((widget) => {
      const { dataSource } = widget
      const crossFilteringDataSourceIds =
        'crossFilteringDataSourceIds' in widget ? widget.crossFilteringDataSourceIds : undefined

      return (
        dataSource === dataSourceId || (crossFilteringDataSourceIds && crossFilteringDataSourceIds.includes(dataSource))
      )
    })
    .find((widget) => widget.type === WidgetType.RANGE) as RangeWidget | undefined

  if (firstRangeWidgetFromDataSource?.column === column) {
    if (firstRangeWidgetFromDataSource?.min !== undefined || firstRangeWidgetFromDataSource?.max !== undefined) {
      return firstRangeWidgetFromDataSource
    }
  }

  return undefined
}

export enum WidgetCompatibilityReason {
  TILESET_OR_RASTER_WITHOUT_LAYER = 'tileset-or-raster-without-layer'
}

export const checkDataSourceWidgetCompatibility = ({
  layers,
  source
}: {
  layers: Layer[]
  source?: BuilderDataset
}): { compatible: boolean; reason?: WidgetCompatibilityReason } => {
  if (!source) return { compatible: true }

  if (source.type === MapType.tileset || source.type === MapType.raster) {
    if (!layers.some((layer) => layer.config.dataId === source.id)) {
      return {
        compatible: false,
        reason: WidgetCompatibilityReason.TILESET_OR_RASTER_WITHOUT_LAYER
      }
    }
  }
  return { compatible: true }
}

export function getWidgetState<T extends Widget>(widget: T): T['state'] {
  return (widget.state || { state: WidgetStateType.Loading }) as T['state']
}

export function isWidgetLoading(widget: Widget | undefined) {
  return !widget?.state || widget?.state?.state === WidgetStateType.Loading
}
